module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    attrs: {
      "inline": "",
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "校区名称"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择校区",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "schoolId", $$v)
      },
      expression: "queryForm.schoolId"
    }
  }, _vm._l((_vm.schoolList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.rootUnid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备UID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入设备UID",
      "clearable": "",
      "maxlength": 100
    },
    model: {
      value: (_vm.queryForm.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "uid", $$v)
      },
      expression: "queryForm.uid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "在线状态"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.queryForm.status),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "status", $$v)
      },
      expression: "queryForm.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "在线",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "离线",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickQuery
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "80",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "设备名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "设备UID",
      "prop": "uid"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "激活日期",
      "width": "200",
      "prop": "activeTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "最后心跳",
      "width": "200",
      "prop": "heartbeatTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "在线状态",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.status === 1 ? "是" : "否"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "380"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.clickDetail(row)
            }
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.clickLogDownload(row)
            }
          }
        }, [_vm._v("日志下载")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.clickEditName(row)
            }
          }
        }, [_vm._v("编辑名称")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.clickDelete(row)
            }
          }
        }, [_vm._v("设备删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.queryForm.pageNum,
      "page-size": _vm.queryForm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeCurrentPage
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "日志下载",
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.logDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickDonload
          }
        }, [_vm._v("下载")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.logDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.logDialog, "visible", $$v)
      },
      expression: "logDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择日志"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择日志",
      "filterable": ""
    },
    model: {
      value: (_vm.logDialog.selectPath),
      callback: function($$v) {
        _vm.$set(_vm.logDialog, "selectPath", $$v)
      },
      expression: "logDialog.selectPath"
    }
  }, _vm._l((_vm.logDialog.data), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-wrapper",
      "title": "编辑名称",
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.editDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickEditDone
          }
        }, [_vm._v("确定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.editDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.editDialog, "visible", $$v)
      },
      expression: "editDialog.visible"
    }
  }, [_c('el-form', {
    ref: "editFormRef",
    attrs: {
      "model": _vm.editDialog.form,
      "rules": _vm.editDialog.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 9,
      "show-word-limit": "",
      "clearable": ""
    },
    model: {
      value: (_vm.editDialog.form.name),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.form, "name", $$v)
      },
      expression: "editDialog.form.name"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54b669f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentSit/EquipmentSit.vue
// module id = 1030
// module chunks = 0